export const DEFAULT_MOBILE_HEADER_HEIGHT = 75;
export const DEFAULT_DESKTOP_HEADER_HEIGHT = 125;
